import Lottie from 'lottie-react';
import { useEffect, useState } from 'react';

export function Animation({ loop = false, delay = 0, style, animationData }: { loop?: boolean; delay?: number; style?: React.CSSProperties; animationData: any }) {
   const [isVisible, setIsVisible] = useState(false);

   useEffect(() => {
      setTimeout(() => {
         setIsVisible(true);
      }, delay);
   }, [delay]);

   if (!isVisible) {
      return null;
   }
   return (
      <Lottie
         animationData={animationData}
         loop={loop}
         style={style}
      />
   );
}
